{
  "name": "@ns/company-relationship-edit",
  "version": "1.1.0",
  "requiredPermission": "RELATIONSHIPS_MANAGE",
  "description": "Edit a commercial relationship",
  "inputs": {
    "relationshipId": {
      "type": "string"
    }
  },
  "outcomes": {
    "save": {},
    "cancel": {}
  }
}
